var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaculty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.904,
    viewBox: "0 0 20 19.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -0.994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,17.41v5.78h5.78l-1.205-1.205H10.205V18.615Z",
    transform: "translate(-2.778 -6.515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.822,19.866l-1.731-1.755v1.58H3.206v-2.5H4.412v-.965H3.206v-4.01H4.412v-.965H3.206V7.39H4.412V6.425H3.206V3.054l9.612,9.558v-1.7L3.031,1.173A.6.6,0,0,0,2,1.6V20.295a.6.6,0,0,0,.6.6h18.79a.6.6,0,0,0,.428-1.031Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.205,19.47h2.411a1.206,1.206,0,0,0,1.205-1.206V6.624L25.436,4.073a1.211,1.211,0,0,0-2.122.048L22,6.636V18.264A1.206,1.206,0,0,0,23.205,19.47Zm0-12.545,1.169-2.274,1.242,2.28v8.92H23.205Zm0,9.909h2.411v1.472H23.205Z",
    transform: "translate(-7.937 -0.984)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaculty);
export default __webpack_public_path__ + "static/media/faculty.d2ce42bc792ca6f0a881e98575051a03.svg";
export { ForwardRef as ReactComponent };